var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.15346 0.408901C9.09877 0.168021 12.3214 0.564867 15.2962 0.395037C18.3559 0.68444 20.5645 3.11577 20.724 6.1571C20.8835 9.19843 20.6442 12.1081 20.6824 15.0142C20.3097 18.014 17.9122 20.1195 14.92 20.2755C12.0371 20.4262 8.99476 20.1975 6.09972 20.2339C3.2931 19.9254 1.08629 17.657 0.834924 14.8496C0.980542 11.8914 0.6477 8.75826 0.834924 5.82091C1.01175 3.04472 3.37805 0.635918 6.15346 0.408901ZM6.61112 2.32208C4.44591 2.48151 2.87358 4.12262 2.74877 6.28014C2.58581 9.07366 2.83198 12.0734 2.80424 14.8791C3.09028 16.7437 4.64354 18.1578 6.51751 18.3207C9.28253 18.1699 12.2642 18.5234 15.0033 18.3207C16.9934 18.1734 18.6212 16.5479 18.7685 14.5567C18.9714 11.8169 18.6177 8.83798 18.7685 6.07392C18.6038 4.18674 17.1719 2.63055 15.291 2.35501C12.4723 2.41219 9.41254 2.11586 6.61285 2.32035L6.61112 2.32208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46572 13.6089C4.8758 11.0181 6.04074 6.51247 9.56332 5.52469C13.2714 4.48665 16.6553 7.9283 15.5319 11.616C14.4779 15.0819 10.0366 16.1789 7.46399 13.6072L7.46572 13.6089ZM10.4804 7.10514C8.21809 7.35989 7.05834 10.0546 8.33423 11.9314C9.63267 13.8411 12.5381 13.699 13.632 11.6697C14.8489 9.4117 13.0114 6.82094 10.4804 7.10514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2043 5.82966C14.1555 4.7483 15.7625 3.13665 16.8356 4.17816C17.9086 5.21966 16.2583 6.91275 15.2043 5.82966Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_81"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.775879 0.329285)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/insta_icon.09b7022ca025131db3beb0245c04b737.svg";
export { ForwardRef as ReactComponent };